interface SavedAddress {
  name: string;
  address: string;
  [key: string]: any;
}

interface ParsedAddress extends Omit<SavedAddress, 'address'> {
  address: any;
}

export function parseAddress(
  savedAddresses: SavedAddress[] | undefined,
  keyValue: string | undefined
): ParsedAddress | null {
  if (!savedAddresses?.length || !keyValue) return null;
  const foundAddress = savedAddresses.find(
    (address) => address.method === keyValue
  );
  if (!foundAddress) return null;
  try {
    return {
      ...foundAddress,
      address: JSON.parse(foundAddress.address),
    };
  } catch (error) {
    return null;
  }
}
